<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card v-if="group">
          <v-card-title>{{group.name}}</v-card-title>
          <v-card-subtitle>Valeur globale : {{group.value}}</v-card-subtitle>
          <v-card-text>
            <v-card
              v-for="item in group.elements"
              :key="item._id"
              :color="item.deletedDate ? 'grey lighten-3' : ''"
              class="ma-5"
              @click="$router.push(`/elements/${item._id}`)"
              :ripple="false"
            >
              <v-card-title>
                {{item.name}}
                <v-spacer />
                <v-tooltip left v-if="item.group">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-information-outline</v-icon>
                  </template>
                  <span>{{item.group.name}}</span>
                </v-tooltip>
              </v-card-title>
              <v-card-subtitle>{{item.inventoryNumber}}</v-card-subtitle>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ["group"]
};
</script>